
import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import DocumentUpload from "./images/upload-document.svg";
import ArrowIcon from "../arrow";
import { documentationStep } from "./selector";

const PostInspectionDiyStartDocumentation = ({
    handleStartDocumentation,
    inspectionResponse
}) => {
    const { priceDiscovery = "", purchaseRequestStatus = ""} = inspectionResponse || {};
    const {description: desc, ctaText} = documentationStep(priceDiscovery, purchaseRequestStatus);
    return (
        <div styleName={"styles.documentCard"}>
            <img src={DocumentUpload} alt="upload"/>
            <div styleName={"styles.documentText"}>
                <p>{desc}</p>
                <div styleName={"styles.startNowCta"} onClick={handleStartDocumentation}>
                    {ctaText}
                    <ArrowIcon/>
                </div>
            </div>

        </div>
    );
};

PostInspectionDiyStartDocumentation.propTypes = {
    handleStartDocumentation: PropTypes.func,
    inspectionResponse: PropTypes.object
};

export default PostInspectionDiyStartDocumentation;
